import { render } from "./CatalogReferral.vue?vue&type=template&id=168e721c&scoped=true&ts=true"
import script from "./CatalogReferral.vue?vue&type=script&lang=ts"
export * from "./CatalogReferral.vue?vue&type=script&lang=ts"

import "./CatalogReferral.vue?vue&type=style&index=0&id=168e721c&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168e721c"]])

export default __exports__